import { Permiso } from './../../../../_entities/Enums/permiso.enum';
import { ReporteMedidores } from './../../../../_entities/medidores/ReporteMedidores';
import { MicromedidorUltimaTransmision } from './../../../../_entities/micromedidores/micromedidor';
import { Medidores } from './../../../../_entities/medidores/Medidores';
import { DatePipe, PercentPipe } from '@angular/common';
import { TablasService } from './../../services/tablas.service';
import { Component, OnInit, ElementRef, ViewChild, AfterContentInit, AfterViewInit } from '@angular/core';
import { Alertado } from './../../../../_entities/consola/alertados';
import { Activo } from './../../../../_entities/activos/activo';
import { Telefono } from './../../../../_entities/telefonos/telefono';
import { AuthService } from './../../../../views/auth/auth.service';
import { BrowserModule } from '@angular/platform-browser';
import { GraficasHw } from '../../../../_entities/tablero/graficas-hw';
import { Router } from '@angular/router';
import { MapaService } from './../../../../views/monitoreo/services/mapa.service';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Portatil } from '../../../../_entities/Portatiles/Portatil';

@Component({
	selector: 'kt-tablas',
	templateUrl: './tablas.component.html',
	styleUrls: ['./tablas.component.scss']
})
export class TablasComponent implements OnInit, AfterContentInit {
	public permisoVisualizarVehiculo: string;
	public permisoVisualizarMedidores: string;
	public permisoVisualizarMicromedidores: string;
	public permisoVisualizarActivos: string;
	public permisoVisualizarTelefonos: string;
	public permisoVisualizarSemaforo: string;
	public permisoVisualizarPortatiles: string;

	public permisoAlertaSalidaGeocerca: string;
	public permisoMostrarAlertasMDVR: string;
	public permisoSaldoPasajero:string;
	public totalVehiculos: number = 0;
	public vehiculosEnMovimiento: number = 0;
	public vehiculosFueraGeocerca: number = 0;
	public totalMedidores: number = 0;
	public totalMicromedidores: number = 0;
	public totalPortatiles:number=0;
	public totalAlertados: number = 0;
	public totalActivos: number = 0;
	public totalTelefonos: number = 0;
	public saldo:number=0;
	public esHW: boolean = false;

	public graficas: any = [];

	public ultimimasDatosDataSource: any;
	public ultimasMicromedidores: any;

	public user;
	public hwUser;

	public datosPastel;
	public datosBarras;

	public mostrarBarras: boolean = false;
	public mostrarPastel: boolean = false;

	public interval = null;

	alertasHW: any[] = [];
	valueField: string = 'dia';
	slideshowDelay = 2000;



	public totalAlertasParadas: GraficasHw;
	public totalAlertasVideoPuertaAbierta: GraficasHw;
	public totalVideosPuertaAbierta: GraficasHw;
	public alertasExcesoVelocidadHW: GraficasHw;

	public longtabs = [
		{ titulo: "Gasto" },
		{ titulo: "Totalizador" }
	];

	constructor(private tablasService: TablasService, private datePipe: DatePipe,
		private authService: AuthService, private pipe: PercentPipe, private router: Router,
		private mapaService: MapaService, private dialog: MatDialog, private toastService: ToastrService) {
	}

	ngOnInit() {
		this.hwUser = this.authService.getHWUser();
		this.user = this.authService.getUser();
		if (this.user.idCliente == 39) {
			this.esHW = true;
		}

		this.obtenerTotalVehiculosActivos();
		this.obtenerTotalVehiculosMovimiento();
		this.obtenerTotalVehiculosFueraGeocerca();
		this.obtenerTotalAlertados();
		this.obtenerUltimosDatosMedidor();
		this.obtenerMedidores();
		this.obtenerMicromedidores();
		this.obtenerActivos();
		this.obtenerTelefonos();
		this.obtenerGraficaPastel();
		this.obtenerGraficaBarras();
		this.obtenerAlertasHowen();
		this.graficaAlertasParadas();
		this.graficaGeneralVideosPuertaAbierta();
		this.graficaAlertasVideoPuertaAierta();
		this.excesoVelocidadHW();
		this.obtenerTotalVehiculosMovimientoHowen()
		this.obtenerPermisos();
		this.obtenerSaldoPasajeros();
		this.obtenerPortatiles();
	}

	ngAfterContentInit() {
		this.interval = setInterval(async () => {
			this.alertasHW = [];
			//this.obtenerTotalVehiculosActivos();
			//this.obtenerTotalVehiculosMovimiento();
			//this.obtenerTotalVehiculosFueraGeocerca();
			//this.obtenerTotalAlertados();
			//this.obtenerUltimosDatosMedidor();
			//this.obtenerMedidores();
			//this.obtenerMicromedidores();
			//this.obtenerActivos();
			//this.obtenerTelefonos();
			this.obtenerGraficaPastel();
			this.obtenerGraficaBarras();
			this.obtenerAlertasHowen();
			this.graficaAlertasParadas();
			this.graficaGeneralVideosPuertaAbierta();
			this.graficaAlertasVideoPuertaAierta();
			this.excesoVelocidadHW();
			this.obtenerSaldoPasajeros();
			//this.obtenerPermisos();
		}, 30000);
	}

	ngOnDestroy(): void {
		clearInterval(this.interval);
	}

	irMonitoreo(alerta) {
		this.mapaService.abrirModalContador(alerta);
		this.router.navigateByUrl('/home/monitoreo/mapa');
	}

	alertasHeader() {
		if (this.vehiculosFueraGeocerca > 0) {
			this.mapaService.abrirModalHeader();
			this.router.navigateByUrl('/home/monitoreo/mapa');
		} else {
			this.toastService.info('No hay vehículos fuera de geocerca');
		}
	}

	semaforo(e) {
		let argument = e.target.initialArgument;

		switch (argument) {
			case 'Autos detenidos':
				this.irMonitoreo('gris');
				break;
			case 'En movimiento':
				this.irMonitoreo('verde');
				break;
			case 'Detenidos mas de 90 min':
				this.irMonitoreo('rojo');
				break;
			case 'Detenidos mas de 60 min':
				this.irMonitoreo('naranja');
				break;
			case 'Detenidos mas de 30 min':
				this.irMonitoreo('amarillo');
				break;
			case 'Exceso de velocidad':
				this.irMonitoreo('azul');
				break;
			default:
				break;
		}

	}

	medidores() {
		this.mapaService.abrirModalmedidores();
		this.router.navigateByUrl('/home/monitoreo/mapa');

	}

	micromedidores() {
		this.mapaService.abrirModalmicromedidores();
		this.router.navigateByUrl('/home/monitoreo/mapa');

	}

	activos() {
		this.mapaService.abrirModalactivos();
		this.router.navigateByUrl('/home/monitoreo/mapa');

	}

	portatiles(){
			this.mapaService.abrirModalPortatiles();
			this.router.navigateByUrl('/home/monitoreo/mapa');
	
	}

	telefonos() {
		this.mapaService.abrirModaltelefonos();
		this.router.navigateByUrl('/home/monitoreo/mapa');

	}

	irAdministracionVehiculos() {
		this.router.navigateByUrl('/home/administracion/vehiculos/vehiculo');
	}

	irAdministracionConsola() {
		this.router.navigateByUrl('/home/administracion/consola/alertados')
	}

	obtenerTotalVehiculosActivos() {
		this.tablasService.getTotalVehiculosActivos().subscribe(
			res => {
				this.totalVehiculos = res.total;
			}, err => {
				console.log(err);
			}
		);
	}

	obtenerTotalVehiculosMovimiento() {
		this.tablasService.getTotalVehiculosMovimiento().subscribe(
			res => {
				this.vehiculosEnMovimiento = res.total;
			}, err => {
				console.log(err);
			}
		);
	}

	obtenerTotalVehiculosMovimientoHowen() {
		/*let token = '';
		if (this.hwUser) {
			token = this.hwUser.token;
		}*/
		this.tablasService.obtenerAutosMovimientoHowen().subscribe(
			(vehiculos: any) => {
				this.vehiculosEnMovimiento = this.vehiculosEnMovimiento + vehiculos;
			}
		)

	}

	obtenerTotalVehiculosFueraGeocerca() {
		/*let token = '';
		if (this.hwUser) {
			token = this.hwUser.token;
		}*/
		this.tablasService.getTotalVehiculosFueraGeocerca().subscribe(
			res => {
				this.vehiculosFueraGeocerca = res.total;
			}, err => {
				console.log(err);
			}
		);
	}

	obtenerTotalAlertados() {
		this.tablasService.getTotalAlertados().subscribe(
			(alertados) => {
				this.totalAlertados = Number(alertados);
			}, (error) => {
				console.log(error);

			}
		);
	}

	obtenerUltimosDatosMedidor() {
		this.tablasService.obtenerUltimoDatoMedidor().subscribe(
			(response) => {
				this.ultimimasDatosDataSource = response;
				this.totalMedidores = response.length;
			}
		)
	}

	obtenerMedidores() {
		this.tablasService.obtenerMedidores().subscribe(
			(medidores: Medidores[]) => {
				for (let medidor of medidores) {
					let imei = medidor.imei;
					let descripcion = medidor.descripcion;
					this.obtenerGraficaInfo(imei, descripcion);
				}
			}
		);
	}

	obtenerSaldoPasajeros(){
	this.tablasService.obtenerSaldoPasajero().subscribe(result=>{
		this.saldo = result;
	},err=>{
	
	})	
	}

	obtenerMicromedidores() {
		let newResponse = [];
		let temNumSeries = [];
		this.tablasService.obtenerMicromedidores().subscribe(
			(micromedidores: MicromedidorUltimaTransmision[]) => {
				micromedidores.map(function (micromedidor) {
					if (micromedidor.observacion == '' || micromedidor.observacion == null) {
						micromedidor.observacion = 'Sin datos';
					}
				})
				micromedidores.forEach(
					(micromedidor) => {
						let numeroSerie = micromedidor.numeroSerie;

						if (!(temNumSeries.includes(numeroSerie))) {
							temNumSeries.push(numeroSerie);
							newResponse.push(micromedidor);
						}
					}
				);

				this.totalMicromedidores = newResponse.length;
				this.ultimasMicromedidores = newResponse;
			}
		)
	}

	obtenerActivos() {
		this.tablasService.obtenerActivos().subscribe(
			(activos: Activo[]) => {
				if (activos.length) {
					this.totalActivos = activos.length;
				}
			}
		);
	}

	obtenerPortatiles() {
		this.tablasService.obtenerPortatiles().subscribe(
			(portatiles: Portatil[]) => {
				if (portatiles.length) {
					this.totalPortatiles = portatiles.length;
				}
			}
		);
	}

	obtenerTelefonos() {
		this.tablasService.obtenerTelefonos().subscribe(
			(telefonos: Telefono[]) => {
				if (telefonos.length) {
					this.totalTelefonos = telefonos.length;
				}
			}
		);
	}

	obtenerAlertasHowen() {
		/*let token = '';
		if (this.hwUser) {
			token = this.hwUser.token;
		}*/

		this.tablasService.obtenerAlertasHowen().subscribe(
			(alertas: number) => {
				this.totalAlertados = this.totalAlertados + alertas;
			}
		)
	}

	obtenerGraficaInfo(imei: Number, descripcion: string) {
		const diaActual = new Date()
		const milisegundos = 1000 * 60 * 60 * 1152 //Cuantos milisegundos hay en 24 hrs
		//getTime devuelve los milisegundos de la fecha
		const diaAnteriorMilisegundos = diaActual.getTime() - milisegundos; //Dia anterior en milisegundos
		const diaAnterior = new Date(diaAnteriorMilisegundos)

		const fechaInicial = this.datePipe.transform(diaAnterior, "yyyy-MM-dd HH:mm:ss")
		const fechaFinal = this.datePipe.transform(diaActual, "yyyy-MM-dd HH:mm:ss")

		this.tablasService.obtenerReportePosicionesMedidores(imei, fechaInicial, fechaFinal).subscribe(
			(response: ReporteMedidores[]) => {
				if (response.length) {
					const aux = {
						'imei': imei,
						'descripcion': descripcion,
						'data': response
					}
					this.graficas.push(aux);
				}
			}
		)
	}

	customizeEtiqueta(arg) {
		return arg.valueText + ' m3';
	}

	customizeTooltip() { }

	/*Etiqueta en grafica pastel*/
	etiquetaPie(arg) {
		return arg.valueText + ' Vehículos'
	}

	/*Color de partes de grafica pastel*/
	customizePoint(pointInfo: any) {
		switch (pointInfo.data.tipo) {
			case 0:
				return { color: '#858585' }
			case 1:
				return { color: '#188c18' }
			case 4:
				return { color: '#f9c300' }
			case 5:
				return { color: '#ff8100' }
			case 6:
				return { color: '#ff0000' }
			case 7:
				return { color: '#2a82ef' }
			case 8:
				return { color: '#800080' }
		}


	};

	legendItems(arg) {
		return 'Económico: ' + arg.valueText;
	}

	valueItems(arg) {
		return arg.valueText + ' km/h';
	}

	obtenerGraficaPastel() {
		/*let token = '0';
		if (this.hwUser) {
			token = this.hwUser.token;
		}*/
		this.tablasService.obtenerDatosGricaPastel().subscribe(
			(response) => {
				this.datosPastel = [
					{
						etiqueta: 'Detenidos mas de 90 min',
						val: response.totalDetenidosMas90,
						tipo: 6
					},
					{
						etiqueta: 'Detenidos mas de 60 min',
						val: response.totalDetenidosMas60,
						tipo: 5
					},
					{
						etiqueta: 'Detenidos mas de 30 min',
						val: response.totalDetenidosMas30,
						tipo: 4
					},
					{
						etiqueta: 'Exceso de velocidad',
						val: response.totalExcesoVelocidad,
						tipo: 7
					},

					{
						etiqueta: 'Fuera de geocerca',
						val: response.totalFueraGeocerca,
						tipo: 8
					},
					{
						etiqueta: 'Autos detenidos',
						val: response.totalAutosDetenidos,
						tipo: 0
					},
					{
						etiqueta: 'En movimiento',
						val: response.totalMovimiento,
						tipo: 1
					}
				];
			}, (error) => {
				console.log('Error en grafica pastel');
			}
		)
	}

	obtenerGraficaBarras() {
	/*	let token = '0';
		if (this.hwUser) {
			token = this.hwUser.token;
		}
*/
		this.tablasService.obtenerDatosGraficaBarras().subscribe(
			(response) => {
				this.datosBarras = response;
				if (this.datosBarras.length > 0) {
					this.mostrarBarras = true;
				}
			}
		)
	}

	graficaAlertasParadas() {
		this.tablasService.obtenerAlertasParadas().subscribe(
			(alertas: GraficasHw) => {
				alertas.titulo = 'Paradas no autorizadas';
				alertas.color = '#f9c300'
				this.alertasHW.push(alertas);
				//this.totalAlertasParadas = alertas;

			}
		);
	}

	graficaAlertasVideoPuertaAierta() {
		this.tablasService.obtenerAlertasVideoPuertaAbierta().subscribe(
			(alertas: GraficasHw) => {
				alertas.titulo = 'Apertura de puerta';
				alertas.color = '#ff0000'
				this.alertasHW.push(alertas);
				//this.totalAlertasVideoPuertaAbierta = alertas
			}
		);
	}

	graficaGeneralVideosPuertaAbierta() {
		this.tablasService.obtenerAlertasPuertaAbiertaGeneral().subscribe(
			(alertas: GraficasHw) => {
				alertas.titulo = 'Alertas totales';
				alertas.color = '#52bb56';

				if (alertas.dia === null) { alertas.dia = 0; }
				if (alertas.semana === null) { alertas.semana = 0; }
				if (alertas.mes === null) { alertas.mes = 0; }

				this.alertasHW.push(alertas);
			}
		);
	}

	excesoVelocidadHW() {
		this.tablasService.obtenerExcesoVelocidadHW().subscribe(
			(alertas: GraficasHw) => {
				alertas.titulo = 'Exceso de velocidad';
				alertas.color = '#2a82ef'
				this.alertasHW.push(alertas);
			}
		);
	}

	cambiarRango(rango: string) {
		this.valueField = rango;
	}

	public obtenerTitulo(titulo: string) {
		switch (titulo) {
			case 'dia':
				return 'Día';
				break
			case 'semana':
				return 'Semana';
				break;
			case 'mes':
				return 'Mes';
				break;
		}
	}

	etiquetaPieAlertas(arg) {
		return arg.valueText + ' Alertas'
	}

	/*Color de partes de grafica pastel*/
	customizePointAlertas(pointInfo: any) {
		//return pointInfo.data.color
		return { color: pointInfo.data.color };
	};

	public get Permiso() {
		return Permiso
	}

	public mostrarAlertas: boolean;

	obtenerPermisos() {
		this.permisoVisualizarVehiculo = Permiso.VisualizarVehiculos;
		this.permisoVisualizarMedidores = Permiso.VisualizarMedidores;
		this.permisoVisualizarMicromedidores = Permiso.ConsultarMicromedidor;
		this.permisoVisualizarActivos = Permiso.ConsultarActivo;
		this.permisoVisualizarTelefonos = Permiso.ConsultarTelefono;
		this.permisoVisualizarSemaforo = Permiso.MostrarSemaforo;
		this.permisoVisualizarPortatiles = Permiso.VisualizarPortatiles;

		this.permisoAlertaSalidaGeocerca = Permiso.AlertaSalidaGeocerca;
		this.permisoMostrarAlertasMDVR = Permiso.MostrarAlertasDVR;
		this.permisoSaldoPasajero = Permiso.SaldoPasajeros;
		const permisos = this.authService.getUser().permisos;

		if (permisos.includes(this.permisoMostrarAlertasMDVR)) {
			this.mostrarAlertas = true;
		}

	}

}
